import { c as _c } from "react/compiler-runtime";
import TrailerEmptyIcon from '@/components/assets/icon_trailer_empty.svg';
import { useTranslations } from 'next-intl';
const TrailerCarouselEmptyState = () => {
  const $ = _c(12);
  const t = useTranslations();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="h-[72px] w-[72px]"><TrailerEmptyIcon className="h-full w-full object-cover" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("trailer-carousel.default.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <p className="subheader2-omni-styles text-white">{t1}</p>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("trailer-carousel.default.description");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <p className="body1-omni-styles text-vive-primary-30">{t3}</p>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="absolute top-1/2 left-1/2 flex h-[148px] w-[261px] -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center">{t0}{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default TrailerCarouselEmptyState;